/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, useMemo, useCallback } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { getAmc } from "../stores/services/amc.service";
import {
  getLedgerInfoByLedgerCodeWorking,
  getSystemFormat,
  sortAMCS,
  typeRatioSystematic,
} from "../utils/customFunction";
import moment from "moment";
import {
  addInvestmentTransaction,
  getInvestmentTransactionById,
  getModeOfPayments,
  updateVPSTxn,
} from "../stores/services/transactions.service";
import {
  getDailyNavByDate,
  getFundByAmc,
  getInstrumentType,
} from "../stores/services/funds.service";
import { getAccountByFund } from "../stores/services/account.service";
import { getAllUnitHolders } from "../stores/services/unit-holder.service";
import { useCustomStylesDropDown } from "../assets/css/customStyle";
import { getNewChartsOfAccountsByFund } from "../stores/services/chatofaccounts.service";

export interface InvestmentTransactionFields {
  folio_no: string;
  account_number: string;
  account_title: string;
  unitholder_name: string;
  counter_account_title: string;
  counter_account_number: string;
  counter_bank: string;
  counter_branch: string;
  fund_code: string;
  fund_name: string;
  amc_code: string;
  amc_name: string;
  txnr_type: string;
  type: string;
  price: string;
  net_amount: string;
  gross_amount: string;
  discount_on_load: string;
  applicable_unit_load: string;
  current_holding: string;
  total_holding: string;
  sale_load: string;
  nav: string;
  instruction_date: string;
  sale_date: string;
  settlement_date: string;
  bank: string;
  branch: string;
  mode_of_payment: string;
  payment_type: string;
  instrument_type: string;
  instrument_no: string;
  instrument_date: string;
  realized_date: string;
  settlement_by: string;
  detail: string;
  units: string;
  systematic_investment: any;
  txn_id?: string;
  authorization_value?: string;
  authorization_comment?: string;
  txn_status?: string;
  _id?: string;
}

export const useInvestmentTransaction = () => {
  const history = useHistory();
  const email = sessionStorage.getItem("email") || "";
  const role = sessionStorage.getItem("role") || "";
  const amc = sessionStorage.getItem("amc_code") || "";
  const [totalAmount, setTotalAmount] = useState<any>();
  const [totalUnits, setTotalUnits] = useState<any>();
  const [units, setUnits] = useState<any>();
  const [amcOptions, setAmcOptions] = useState<any[]>([]);
  const [fundOptions, setFundOptions] = useState<any[]>([]);
  const [accountOptions, setAccountOptions] = useState<any[]>([]);
  const [offerPrice, setOfferPrice] = useState<any>();
  const [unitholderAccountOptions, setUnitholderAccountOptions] = useState<
    any[]
  >([]);
  const [unitholderOptions, setUnitholderOptions] = useState<any[]>([]);
  const [unitholderLoading, setUnitholderLoading] = useState(false);
  const [unitholderSearchInput, setUnitholderSearchInput] = useState("");
  const [noNav, setNoNav] = useState(false);

  const [modeOfPayments, setModeOfPayments] = useState<string[]>([]);
  const [instrumentTypes, setInstrumentTypes] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);
  const [errorShow, setErrorShow] = useState(false);

  const today = moment().format("YYYY-MM-DD");
  const [allFunds, setAllFunds] = useState<any[]>([]);
  const [errors, setErrors] = useState<any>({});
  // {
  // [key: number | string]: string | null;
  // }
  const [rangeTimer, setRangeTimer] = useState<any>(null);
  const [autoInvest, setAutoInvest] = useState("false");
  const [typeVPS, setTypeVPS] = useState("");
  const [unitholderType, setUnitholderType] = useState("");
  const [amount, setAmount] = useState<any>();
  const [currAmount, setCurrAmount] = useState<any>();
  const [fundLoading, setFundLoading] = useState<any>();
  const [navLoading, setNavLoading] = useState<any>();
  const [subFundsBlocks, setSubFundsBlocks] = useState<any>([]);
  const [currentSubFundsBlock, SetCurrentSubFundsBlock] = useState<any>();
  const { customStyles } = useCustomStylesDropDown();
  const { id } = useParams<{ id?: string }>();
  const location = useLocation();
  const [totalInvestment, setTotalInvesment] = useState(0);
  const [showApproval, setShowApproval] = useState(false);
  const [authroizeDialogue, setAuthorizeDialogue] = useState(false);
  const [decision, setDecision] = useState(""); // "" | "accept" | "reject"
  const [rejectReason, setRejectReason] = useState("");
  const [compliant, setCompliant] = useState("");
  const [compliantComment, setcompliantComment] = useState("");
  const [chartOfAccountsMap, setChartOfAccountsMap] = useState<{
    [key: string]: any[];
  }>({});
  const [vpsLedgers, setVpsLedgers] = useState<any[]>([]);
  const [viewMode, setViewMode] = useState<
    "investment" | "withdrawal" | "changeofallocation" | "view"
  >("investment");
  const [loadingViewData, setTxnLoading] = useState<boolean>(false);

  // New state for fund accounts
  const [fundAccountsMap, setFundAccountsMap] = useState<{
    [key: string]: any[];
  }>({});

  const [fields, setFields] = useState<InvestmentTransactionFields>({
    folio_no: "",
    account_number: "",
    account_title: "",
    unitholder_name: "",
    counter_account_title: "",
    counter_account_number: "",
    counter_bank: "",
    counter_branch: "",
    fund_code: "",
    fund_name: "",
    amc_code: amc,
    amc_name: "",
    txnr_type: "",
    type: "credit",
    price: "",
    net_amount: "",
    gross_amount: "",
    discount_on_load: "",
    applicable_unit_load: "",
    current_holding: "",
    total_holding: "",
    sale_load: "",
    nav: "",
    instruction_date: today,
    sale_date: today,
    settlement_date: today,
    bank: "",
    branch: "",
    mode_of_payment: "",
    payment_type: "Direct Credit",
    instrument_type: "",
    instrument_no: "",
    instrument_date: today,
    realized_date: today,
    settlement_by: "",
    detail: "",
    units: "",
    systematic_investment: null,
  });

  useEffect(() => {
    if (location.pathname.includes("view-vps-transactions"))
      setViewMode("view");
    else if (location.pathname.includes("withdrawal"))
      setViewMode("withdrawal");
    else if (location.pathname.includes("investment"))
      setViewMode("investment");
    else if (location.pathname.includes("changeofallocation"))
      setViewMode("changeofallocation");
  }, []);

  const fetchInitialUnitholders = async (amcCode?: string) => {
    try {
      setUnitholderLoading(true);
      const response = await getAllUnitHolders(email, "1", "100", {
        type: "Participant",
      });

      if (response.data.status === 200) {
        const options = response.data.data.map((uh: any) => {
          return {
            value: uh?.folio_no,
            label: `${uh?.folio_no} - ${uh?.name}`,
            unitholder_name: uh?.name,
            folio_no: uh?.folio_no,
            account_title: uh?.account_title,
            account_no: uh?.account_no,
            bank_name: uh?.bank_name,
            branch_name: uh?.branch_name,
            systematic_investment: uh?.systematic_investment || {},
          };
        });
        setUnitholderOptions(options);
      } else {
        setUnitholderOptions([]);
      }
    } catch (err: any) {
      toast.error(err?.response?.data?.message || "Failed to load unitholders");
      setUnitholderOptions([]);
    } finally {
      setUnitholderLoading(false);
    }
  };

  // Fetch initial data
  useEffect(() => {
    const fetchInitialData = async () => {
      if (viewMode === "view") return;
      if (!amc) return;
      try {
        const [_, modeRes, instrumentRes] = await Promise.all([
          fetchInitialUnitholders(amc),
          getModeOfPayments(email),
          getInstrumentType(email),
        ]);

        setModeOfPayments(modeRes.data.mode_of_payment);
        setInstrumentTypes(instrumentRes.data.instrument_types);
      } catch (err: any) {
        toast.error(
          err?.response?.data?.message || "Failed to load initial data",
        );
      }
    };

    if (!location.pathname.includes("view-client")) fetchInitialData();
  }, [email, role, amc]);

  const searchUnitholders = async (searchValue: string) => {
    if (!searchValue || searchValue.length < 2) {
      await fetchInitialUnitholders();
      return;
    }

    try {
      setUnitholderLoading(true);
      const response = await getAllUnitHolders(email, "", "", {
        search_value: searchValue,
        type: "Participant",
      });

      if (response.data.status === 200) {
        // const options = response.data.data.map((uh: any) => ({
        const options = response.data.data?.map((uh: any) => ({
          value: uh?.folio_no,
          label: `${uh?.folio_no} - ${uh?.name}`,
          unitholder_name: uh?.name,
          folio_no: uh?.folio_no,
          account_title: uh?.account_title,
          account_no: uh?.account_no,
          bank_name: uh?.bank_name,
          branch_name: uh?.branch_name,
          systematic_investment: uh?.systematic_investment || {},
        }));
        setUnitholderOptions(options);
      } else {
        setUnitholderOptions([]);
      }
    } catch (err: any) {
      toast.error(
        err?.response?.data?.message || "Failed to search unitholders",
      );
    } finally {
      setUnitholderLoading(false);
    }
  };

  useEffect(() => {
    if (!fields.amc_code || viewMode === "view") return;
    const timeoutId = setTimeout(() => {
      if (unitholderSearchInput) {
        searchUnitholders(unitholderSearchInput);
      }
    }, 500);

    return () => clearTimeout(timeoutId);
  }, [unitholderSearchInput]);

  const handleAmcChange = async (selected: any) => {
    if (!selected) return;

    setFields((prev) => ({
      ...prev,
      amc_code: selected.value,
      amc_name: selected.name,
      fund_code: "",
      fund_name: "",
      account_number: "",
      account_title: "",
      bank: "",
      branch: "",
      counter_account_title: "",
      counter_account_number: "",
      counter_bank: "",
      counter_branch: "",
      nav: "",
      price: "",
      folio_no: "",
      unitholder_name: "",
    }));
    setFundOptions([]);
    setAccountOptions([]);
    setUnitholderAccountOptions([]);
    setUnitholderOptions([]);
    setUnitholderSearchInput("");

    try {
      const res = await getFundByAmc(email, selected.value);
      const options = res.data.data.map((f: any) => ({
        value: f.symbol_code,
        label: `${f.fund_name} (${f.symbol_code})`,
        nav: f.nav,
        face_value: f.face_value,
        fund_name: f.fund_name,
      }));
      setFundOptions(options);
      await fetchInitialUnitholders(selected.value);
    } catch (err: any) {
      toast.error(err?.response?.data?.message || "Failed to load data");
    }
  };

  const handleFundChange = async (selected: any) => {
    if (!selected) return;

    setFields((prev) => ({
      ...prev,
      fund_code: selected.value,
      fund_name: selected.fund_name,
      nav: "",
      price: "",
      account_number: "",
      account_title: "",
      bank: "",
      branch: "",
      counter_account_title: "",
      counter_account_number: "",
      counter_bank: "",
      counter_branch: "",
    }));

    try {
      const res = await getAccountByFund(
        email,
        selected.value,
        fields.amc_code,
      );
      const options = res.data.data.map((acc: any) => ({
        value: acc.account_code,
        label: `${acc.account_title} - ${acc.account_no}`,
        ...acc,
      }));
      setAccountOptions(options);
      setUnitholderAccountOptions(options);

      const { data } = await getDailyNavByDate(
        email,
        selected.value,
        fields.sale_date,
        fields.amc_code,
      );
      if (data?.data) updateField("nav", data?.data.offer_price || "0");
    } catch (err: any) {
      toast.error(err?.response?.data?.message || "Failed to load accounts");
    }
  };

  const handleSaleDateChange = async (date: string) => {
    setNoNav(false);

    // Update NAV for main fund if selected
    if (fields.fund_code) {
      const { data } = await getDailyNavByDate(
        email,
        fields.fund_code,
        date,
        fields.amc_code,
      );

      if (data?.data) updateField("nav", data?.data.offer_price || "0");
    }

    // Update NAV for all subfunds in systematic investment
    if (subFundsBlocks.length > 0) {
      await updateAllSubFundsNavs(date);
    }
  };

  //  Fetch accounts for a specific fund
  const fetchAccountsForFund = async (fundCode: string) => {
    try {
      const res = await getAccountByFund(email, fundCode, fields.amc_code);

      const accounts = res.data.data.map((acc: any) => ({
        value: acc.account_code,
        label: `${acc.account_title} - ${acc.account_no}`,
        account_no: acc.account_no,
        account_title: acc.account_title,
        account_purpose: acc.account_purpose || [],
        ...acc,
      }));

      setFundAccountsMap((prev) => ({
        ...prev,
        [fundCode]: accounts,
      }));

      return accounts;
    } catch (err: any) {
      toast.error(
        err?.response?.data?.message ||
          `Failed to load accounts for fund ${fundCode}`,
      );
      return [];
    }
  };

  //  Auto-select Collection account
  const findCollectionAccount = (accounts: any[]) => {
    const collectionAccount = accounts.find(
      (acc) =>
        acc.account_purpose &&
        Array.isArray(acc.account_purpose) &&
        acc.account_purpose.includes("Collection"),
    );
    return collectionAccount || null;
  };

  //  Fetch NAV for a specific fund
  const fetchNavForFund = async (fundCode: string, date: string) => {
    try {
      const { data } = await getDailyNavByDate(
        email,
        fundCode,
        date,
        fields.amc_code,
      );

      if (data?.data) {
        setOfferPrice(data.data.offer_price || "0");
        return {
          nav: parseFloat(data.data.nav),
          offer_price: parseFloat(data.data.offer_price),
          redemption_price: parseFloat(data.data.redemption_price),
        };
      }
      return "0";
    } catch (err: any) {
      console.error(`Failed to fetch NAV for ${fundCode}:`, err);
      return "0";
    }
  };

  const calculateUnits = (
    amount: string | number,
    nav: string | number,
  ): string => {
    const amountNum = parseFloat(amount.toString()).toFixed(4) || 0;
    const navNum = parseFloat(String(nav)).toFixed(4) || 0;

    if (navNum === 0) return "0.0000";

    const units: any = +amountNum / +navNum;
    return units.toFixed(4);
  };

  //  Update NAVs for all subfunds
  const updateAllSubFundsNavs = async (date: string) => {
    setNoNav(false);
    setSubFundsBlocks((prevBlocks: any) =>
      prevBlocks.map(async (block: any) => {
        if (!block.subFunds || block.subFunds.length === 0) return block;

        let total_nav: any = {};
        const updatedSubFunds = await Promise.all(
          block.subFunds.map(async (fund: any) => {
            if (!fund.fund_code) return fund;

            const navData: any = await fetchNavForFund(fund.fund_code, date);

            const nav =
              viewMode === "withdrawal"
                ? navData?.redemption_price
                : viewMode === "investment"
                  ? navData?.offer_price
                  : viewMode === "changeofallocation"
                    ? fund?.allocation_type &&
                      fund.allocation_type === "conversionin"
                      ? navData.offer_price
                      : navData.redemption_price
                    : "0";
            total_nav[fund.type_VPS] = isNaN(nav) ? 0 : nav;

            const units = calculateUnits(fund.amount || "0", nav);

            return {
              ...fund,
              nav,
              ...(viewMode === "changeofallocation" && {
                offer_price: navData.offer_price,
                redemption_price: navData.redemption_price,
              }),
              units,
            };
          }),
        );

        if (Object.values(total_nav).every((value) => value === 0)) {
          setNoNav(true);
        }

        return {
          ...block,
          subFunds: updatedSubFunds,
        };
      }),
    );
  };

  //  Handle account selection for subfund
  const handleSubFundAccountChange = (
    blockId: string,
    fundIndex: number,
    selectedAccount: any,
  ) => {
    setErrors({});
    setSubFundsBlocks((prevBlocks: any) =>
      prevBlocks.map((block: any) => {
        if (block.id !== blockId) return block;

        const updatedSubFunds = [...block.subFunds];
        updatedSubFunds[fundIndex] = {
          ...updatedSubFunds[fundIndex],
          selected_account: selectedAccount,
          account_no: selectedAccount?.account_no || "",
        };

        return {
          ...block,
          subFunds: updatedSubFunds,
        };
      }),
    );
  };

  const handleAccountChange = (selected: any) => {
    if (!selected) return;
    setFields((prev) => ({
      ...prev,
      account_number: selected.account_no,
      account_title: selected.account_title,
      bank: selected.bank_name,
      branch: `${selected.branch_name} — ${selected.city || ""}`,
    }));
  };

  const updateNav = async () => {
    setNavLoading(true);
    await handleSaleDateChange(fields.sale_date);
    await handleUnitholderChange(
      unitholderOptions.find((opt) => opt.folio_no === fields.folio_no),
    );
    setNavLoading(false);
  };

  const validate = () => {
    const required = ["amc_code", "folio_no", "unitholder_name"];

    if (!amount && viewMode === "withdrawal") {
      setIndexedError("withdrawal", "Amount is 0 Can't create transaction");
      return false;
    }

    for (const key of required) {
      if (
        !fields[key as keyof InvestmentTransactionFields]?.toString().trim()
      ) {
        return false;
      }
    }
    return true;
  };

  const validateInvestmentBlock = (block): boolean => {
    let valid = true;
    let totalUnits = 0;
    block[0].subFunds.forEach((fund) => {
      if (!fund.selected_account) {
        setIndexedError(`${fund.fund_code}:account`, "please select account");
        valid = false;
      }
      totalUnits += parseFloat(fund.uints);
    });

    if (!totalUnits && totalUnits < 1) {
      setIndexedError(
        "units_0",
        "Can't Create Transaction when sum of all the fund units is zero",
      );
      return false;
    }

    return valid;
  };
  const handleSubmit = async () => {
    setErrorShow(false);

    if (!validate()) {
      setErrorShow(true);
      toast.error("Please fill all required fields.");
      return;
    }
    if (noNav) {
      toast.error("Can't create Transaction: Nav is Zero");
      return;
    }

    setLoading(true);
    try {
      if (Object.values(errors).some((value) => value !== null)) {
        toast.error("Kindly Resolve Error in Systematic investment");
        setLoading(false);
        return;
      }

      const systematicInvestment: any = {
        total_block_invest: subFundsBlocks[0].parentProportion,
        allocation_scheme: typeVPS,
        investment_amount: amount,
        investment_blocks: subFundsBlocks,
      };
      const isValid = validateInvestmentBlock(subFundsBlocks);

      if (!isValid) return;
      const total = {
        amount_in: 0,
        amount_out: 0,
        units_in: 0,
        units_out: 0,
      };
      if (viewMode === "changeofallocation") {
        const processedSubFunds = subFundsBlocks.map((block) => {
          const updatedSubFunds = (block.subFunds = block.subFunds.map(
            (fund) => {
              if (fund?.allocation_type === "conversionin") {
                fund.amount_in = parseFloat(
                  parseFloat(fund.amount_in).toFixed(4),
                );
                total.amount_in += fund.amount_in;
                total.units_in += fund.units;
              } else if (fund?.allocation_type === "conversionout") {
                fund.amount_out = parseFloat(
                  parseFloat(fund.amount_out).toFixed(4),
                );
                total.amount_out += fund.amount_out;
                total.units_out += fund.units;
              }
              fund.units = parseFloat(parseFloat(fund.units).toFixed(4));
              const processedFund: any = {
                ...fund,
                allocation_type: fund?.allocation_type,
                ...(fund?.allocation_type === "conversionin" && {
                  amount: fund.amount_in,
                }),
                ...(fund?.allocation_type === "conversionout" && {
                  amount: fund.amount_out,
                }),
                units: fund.units,
                holding: fund.holding,
                account_no: fund.account_no,
                selected_account: fund.selected_account,
              };
              return processedFund;
            },
          ));
          return { ...block, subFunds: updatedSubFunds };
        });

        if (!total.amount_in || !total.amount_out) {
          toast.error("Invalid Transaction Creation Request");
          return;
        }

        if (
          parseFloat(total.amount_in.toFixed(4)) !==
          parseFloat(total.amount_out.toFixed(4))
        ) {
          toast.error("Total of Amount in should be eqaul to Total Amount out");
          return;
        }
        systematicInvestment.investment_blocks = processedSubFunds;
        systematicInvestment.previous_allocation = currentSubFundsBlock;
      }

      const response = await addInvestmentTransaction(email, {
        ...fields,
        net_amount: total.amount_in.toFixed(4),
        gross_amount: total.amount_in.toFixed(4),
        ...(viewMode === "investment" && {
          txnr_type: "investment",
          type: "debit",
        }),
        ...(viewMode === "withdrawal" && {
          txnr_type: "withdrawal",
          type: "debit",
        }),
        ...(viewMode === "changeofallocation" && {
          txnr_type: "changeofallocation",
          type: "debit",
        }),
        systematic_investment: systematicInvestment,
      });

      if (response?.data?.success) {
        toast.success("Transaction submitted successfully!");
        setTimeout(() => {
          history.push("/admin/recent-transactions");
        }, 1000);
      } else {
        toast.error(response.data.message);
      }
    } catch (err: any) {
      toast.error(err?.response?.data?.message || "Submission failed");
    } finally {
      setLoading(false);
    }
  };

  const getErrorClass = (value: string) =>
    errorShow && !value ? "required-border" : "";

  const updateField = (
    key: keyof InvestmentTransactionFields,
    value: string,
  ) => {
    setFields((prev) => ({ ...prev, [key]: value }));
  };

  const handleUnitholderChange = async (
    selected: any,
    date = fields.sale_date,
  ) => {
    setNoNav(false);
    if (!selected) {
      setFields((prev) => ({
        ...prev,
        folio_no: "",
        unitholder_name: "",
        counter_account_title: "",
        counter_account_number: "",
        counter_bank: "",
        counter_branch: "",
      }));
      setSubFundsBlocks([]);
      setTypeVPS("");
      return;
    }

    setTotalUnits(
      parseFloat(
        selected?.systematic_investment?.investment_blocks[0]?.total_holding ||
          0,
      ).toFixed(4),
    );

    const savedBlocks =
      selected?.systematic_investment?.investment_blocks || [];
    const allocationScheme =
      selected?.systematic_investment?.allocation_scheme || "";

    SetCurrentSubFundsBlock(savedBlocks);

    setTypeVPS(allocationScheme);

    setFields((prev) => ({
      ...prev,
      folio_no: selected.folio_no,
      unitholder_name: selected.unitholder_name,
      counter_account_title: selected.account_title,
      counter_account_number: selected.account_no,
      counter_bank: selected.bank_name,
      counter_branch: selected.branch_name,
      systematic_investment: selected?.systematic_investment || {},
    }));

    if (location.pathname.includes("view-vps-transactions")) {
      selected.systematic_investment.investment_blocks[0].total_amount =
        selected?.systematic_investment?.investment_amount;
      setSubFundsBlocks(selected?.systematic_investment?.investment_blocks);
      return;
    }

    const amountToSet = ["withdrawal", "changeofallocation"].includes(viewMode)
      ? 0.0
      : selected?.systematic_investment?.investment_amount || 0;

    setCurrAmount(selected?.systematic_investment?.investment_amount || 0);

    setAmount(amountToSet);
    if (!allocationScheme || savedBlocks.length === 0) {
      setSubFundsBlocks([]);
      return;
    }

    let total_investement = 0;
    let total_amount: any = 0;
    let total_nav: any = {};
    // Rebuild each block with fresh accounts + NAVs for sub-funds
    const rebuiltBlocks = await Promise.all(
      savedBlocks.map(async (block: any) => {
        const parentFundCode = block.fund || block.fund_code;
        if (!parentFundCode) return block;

        // Reconstruct subFunds with fresh data
        const newSubFunds = await Promise.all(
          (block.subFunds || []).map(async (subFund: any) => {
            const fundCode = subFund.fund_code;

            if (!fundCode) {
              return { ...subFund, accounts: [], selected_account: null };
            }

            subFund.holding = parseFloat(
              parseFloat(subFund.holding).toFixed(4),
            );

            // Fetch accounts for this child fund
            const accounts = await fetchAccountsForFund(fundCode);
            const collectionAccount = findCollectionAccount(accounts);

            // Fetch NAV on current sale_date
            const navData: any = await fetchNavForFund(fundCode, date);
            const nav = parseFloat(
              viewMode === "withdrawal"
                ? navData?.redemption_price
                : viewMode === "investment"
                  ? navData?.offer_price
                  : viewMode === "changeofallocation"
                    ? navData.redemption_price
                    : 0,
            );

            total_nav[subFund?.type_VPS] = isNaN(nav) ? 0 : +nav;

            total_amount += nav * (subFund?.holding || 0);
            // Recalculate units
            const amountValue =
              parseFloat(amountToSet) * (parseFloat(subFund.proportion) / 100);
            subFund.amount = amountValue.toFixed(4);
            const units = calculateUnits(amountValue, nav);
            const holding_amount = subFund?.holding * nav;
            total_investement += subFund.holding * nav;

            const updatedSubFund = {
              ...subFund,
              ...(viewMode === "changeofallocation" && {
                counter_fund: { value: "", label: "" },
                holding_amount,
                amount_in: 0,
                amount_out: 0,
              }),
              accounts,
              selected_account: collectionAccount,
              account_code: collectionAccount?.value || "",
              account_no: collectionAccount?.account_no || "",
              account_title: collectionAccount?.account_title || "",

              nav,
              ...(viewMode === "changeofallocation" && {
                offer_price: navData.offer_price,
                redemption_price: navData.redemption_price,
              }),
              units,
            };
            return updatedSubFund;
          }),
        );

        block.total_amount = calculateBlockTotal(newSubFunds, "amount");
        return {
          ...block,
          subFunds: newSubFunds,
        };
      }),
    );

    setTotalAmount(parseFloat(total_amount || 0).toFixed(4));

    if (Object.values(total_nav).every((value) => value === 0)) {
      setNoNav(true);
    }

    if (totalInvestment === 0) {
      setTotalInvesment(total_investement);
    }
    setSubFundsBlocks(rebuiltBlocks);
    return rebuiltBlocks;
  };

  const handleUnitholderInputChange = (inputValue: string) => {
    setUnitholderSearchInput(inputValue);
  };

  const renderRange = (ValueIs) => {
    const filteredType = typeRatioSystematic?.find(
      (ele) => ele?.label === typeVPS,
    );
    if (filteredType && ValueIs) {
      return filteredType.ratio[ValueIs] || "";
    }
    return "";
  };

  const calculateBlockTotal = (subFunds, key = "proportion") => {
    return subFunds.reduce((total, fund) => {
      const proportion = parseFloat(fund[key]) || 0;
      return total + proportion;
    }, 0);
  };

  const removeSubFundsBlock = (blockId) => {
    if (subFundsBlocks.length > 1) {
      setSubFundsBlocks(subFundsBlocks.filter((block) => block.id !== blockId));
    }
  };

  const onAmountChange = (amount: number) => {
    if (amount < 0 || subFundsBlocks.length < 1) return;

    let totalUnits = 0;
    const fundsWithExcess: Array<{
      blockIndex: number;
      fundIndex: number;
      excessAmount: number;
      excessUnits: number;
      fund: any;
    }> = [];

    const fundsWithCapacity: Array<{
      blockIndex: number;
      fundIndex: number;
      availableAmount: number;
      availableUnits: number;
      fund: any;
    }> = [];

    // Helper for float comparison
    const floatEquals = (a: number, b: number, tolerance = 0.0001) =>
      Math.abs(a - b) < tolerance;

    // --- Step 1: Identify funds with excess or capacity ---
    const initialBlocks = subFundsBlocks.map(
      (block: any, blockIndex: number) => {
        if (block.subFunds.length < 1) return block;

        const updatedSubFunds = block.subFunds.map(
          (fund: any, fundIndex: number) => {
            if (fund.proportion <= 0) return fund;

            const newAmount = amount * (parseFloat(fund.proportion) / 100);
            const nav = parseFloat(fund.nav) || 0;
            const units = parseFloat(calculateUnits(newAmount, nav));
            const currentHolding =
              parseFloat(parseFloat(fund.holding).toFixed(4)) || 0;

            if (viewMode === "withdrawal") {
              if (
                units > currentHolding &&
                !floatEquals(units, currentHolding)
              ) {
                // Fund exceeds its holding
                const maxAllowedUnits = currentHolding;
                const maxAllowedAmount = maxAllowedUnits * nav;
                const excessUnits = units - maxAllowedUnits;
                const excessAmount = excessUnits * nav;

                fundsWithExcess.push({
                  blockIndex,
                  fundIndex,
                  excessAmount,
                  excessUnits,
                  fund,
                });
              } else {
                // Fund has capacity left
                const maxAllowedUnits = currentHolding;
                const availableUnits = maxAllowedUnits - units;
                const availableAmount = availableUnits * nav;

                if (availableAmount > 0.01) {
                  fundsWithCapacity.push({
                    blockIndex,
                    fundIndex,
                    availableAmount,
                    availableUnits,
                    fund,
                  });
                }
              }
            }

            return {
              ...fund,
              amount: newAmount.toFixed(4),
              units: units.toFixed(4),
            };
          },
        );

        return { ...block, subFunds: updatedSubFunds };
      },
    );

    // --- Step 2: Redistribute excess between funds ---
    let updatedBlocks = [...initialBlocks];
    let remainingExcess = 0;

    if (viewMode === "withdrawal" && fundsWithExcess.length > 0) {
      const totalExcessAmount = fundsWithExcess.reduce(
        (sum, item) => sum + item.excessAmount,
        0,
      );
      const totalCapacityAmount = fundsWithCapacity.reduce(
        (sum, item) => sum + item.availableAmount,
        0,
      );

      // Case 1: Sufficient capacity to absorb all excess
      if (totalCapacityAmount >= totalExcessAmount) {
        // Cap funds at max allowed holding
        fundsWithExcess.forEach(({ blockIndex, fundIndex, fund }) => {
          const maxUnits = parseFloat(fund.holding).toFixed(4);
          const nav = parseFloat(fund.nav) || 0;
          const maxAmount = parseFloat(maxUnits) * nav;

          updatedBlocks[blockIndex].subFunds[fundIndex] = {
            ...fund,
            amount: maxAmount.toFixed(4),
            units: parseFloat(maxUnits).toFixed(4),
          };
        });

        // Redistribute excess proportionally to available funds
        fundsWithCapacity.forEach(
          ({ blockIndex, fundIndex, availableAmount, fund }) => {
            const proportion = availableAmount / totalCapacityAmount;
            const additionalAmount = totalExcessAmount * proportion;
            const nav = parseFloat(fund.nav) || 0;
            const currentAmount = parseFloat(
              updatedBlocks[blockIndex].subFunds[fundIndex].amount,
            );
            const newAmount = currentAmount + additionalAmount;

            const maxHolding = parseFloat(fund.holding);
            const newUnits = Math.min(newAmount / nav, maxHolding);
            const finalAmount = newUnits * nav;

            updatedBlocks[blockIndex].subFunds[fundIndex] = {
              ...updatedBlocks[blockIndex].subFunds[fundIndex],
              amount: finalAmount.toFixed(4),
              units: newUnits.toFixed(4),
            };
          },
        );

        remainingExcess = 0;
      }
      // Case 2: Not enough capacity available
      else {
        remainingExcess = totalExcessAmount - totalCapacityAmount;

        // Cap funds with excess
        fundsWithExcess.forEach(({ blockIndex, fundIndex, fund }) => {
          const maxUnits = parseFloat(fund.holding).toFixed(4);
          const nav = parseFloat(fund.nav) || 0;
          const maxAmount = parseFloat(maxUnits) * nav;

          updatedBlocks[blockIndex].subFunds[fundIndex] = {
            ...fund,
            amount: maxAmount.toFixed(4),
            units: parseFloat(maxUnits).toFixed(4),
          };
        });

        // Use up all capacity proportionally
        fundsWithCapacity.forEach(
          ({ blockIndex, fundIndex, availableAmount, fund }) => {
            const proportion = availableAmount / totalCapacityAmount;
            const additionalAmount = totalCapacityAmount * proportion;
            const nav = parseFloat(fund.nav) || 0;
            const currentAmount = parseFloat(
              updatedBlocks[blockIndex].subFunds[fundIndex].amount,
            );
            const newAmount = currentAmount + additionalAmount;

            const maxHolding = parseFloat(fund.holding);
            const newUnits = Math.min(newAmount / nav, maxHolding);
            const finalAmount = newUnits * nav;

            updatedBlocks[blockIndex].subFunds[fundIndex] = {
              ...updatedBlocks[blockIndex].subFunds[fundIndex],
              amount: finalAmount.toFixed(4),
              units: newUnits.toFixed(4),
            };
          },
        );
      }
    }

    // --- Step 3: Recalculate totals ---
    updatedBlocks = updatedBlocks.map((block: any) => {
      const blockUnits = block.subFunds.reduce(
        (sum: number, fund: any) => sum + parseFloat(fund.units || 0),
        0,
      );

      totalUnits += blockUnits;
      block.total_amount = calculateBlockTotal(block.subFunds, "amount");

      return block;
    });

    // --- Step 4: Update states ---
    setSubFundsBlocks(updatedBlocks);
    setUnits(totalUnits.toFixed(4));

    // --- Step 5: Handle errors ---
    if (remainingExcess > 0.01) {
      setErrors((prev) => ({
        ...prev,
        withdrawal: `Unable to redistribute ${remainingExcess.toFixed(
          2,
        )} due to insufficient holdings across all funds.`,
      }));
    } else {
      setErrors((prev) => {
        const { withdrawal, ...rest } = prev;
        return rest;
      });
    }
  };

  useEffect(() => {
    if (["changeofallocation", "view", "investment"].includes(viewMode)) return;

    if (amount > 0) {
      onAmountChange(amount);
    } else {
      setUnits("");
    }
  }, [amount]);

  const setIndexedError = (index: number | string, message: string | null) => {
    setErrors((prevErrors) => {
      if (!message) {
        const { [index]: removed, ...rest } = prevErrors;
        return rest;
      }
      return { ...prevErrors, [index]: message };
    });
  };

  const handleCustomCheckboxChange = (
    blockId: any,
    fundIndex: any,
    isChecked: any,
  ) => {
    setSubFundsBlocks((prevBlocks: any) =>
      prevBlocks.map((block: any) => {
        if (block.id !== blockId || !block.subFunds) {
          return block;
        }

        const updatedSubFunds: any = block.subFunds.map((fund, index) => {
          if (index === fundIndex) {
            const newProportion = isChecked ? "100" : "0";
            const newAmount = isChecked ? amount : 0;
            const units = calculateUnits(newAmount, fund.nav || "0");

            return {
              ...fund,
              proportion: newProportion,
              amount: newAmount.toFixed(4),
              units,
            };
          } else if (isChecked) {
            return {
              ...fund,
              proportion: "0",
              amount: "0.00",
              units: "0.0000",
            };
          }
          return fund;
        });

        const newBlockTotal = calculateBlockTotal(updatedSubFunds);
        const newBlockAmountTotal = calculateBlockTotal(
          updatedSubFunds,
          "amount",
        );

        return {
          ...block,
          subFunds: updatedSubFunds,
          parentProportion: newBlockTotal,
          total_amount: newBlockAmountTotal,
        };
      }),
    );
  };

  const getfundByAmcCode = async (code: string) => {
    setFundLoading(true);
    try {
      const response = await getFundByAmc(email, code, "", "", "", "sub_fund");

      setAllFunds(response.data.data);
      if (response.data.data.length > 0) {
        setFundLoading(false);
      } else {
        setFundLoading(true);
      }
    } catch (err: any) {
      if (err.response !== undefined) {
        toast.error(err.response.data.message);
      } else {
        toast.error(err.message);
      }
    }
  };

  useEffect(() => {
    if (viewMode === "view") return;
    if (fields.amc_code) getfundByAmcCode(fields.amc_code);
  }, [fields.amc_code]);

  useEffect(() => {
    if (id) {
      const [txn_id, route] = id.split(":");
      fetchTransactionDetails(txn_id);
      if (route === "compliance") setShowApproval(true);
    }
  }, [id]);

  const fetchTransactionDetails = async (transactionId: string) => {
    try {
      setTxnLoading(true);
      const res = await getInvestmentTransactionById(transactionId);
      if (res?.data?.success) {
        const txn = res.data.data;
        setFields({
          ...txn,
          settlement_date: getSystemFormat(txn.settlement_date),
          sale_date: getSystemFormat(txn.sale_date),
          instruction_date: getSystemFormat(txn.instruction_date),
        });
        setTypeVPS(txn?.systematic_investment?.allocation_scheme || "");

        setAmount(txn?.systematic_investment?.investment_amount || 0);
        if (txn) {
          const unitholderData = {
            value: txn.folio_no,
            label: `${txn.folio_no} - ${txn.unitholder_name}`,
            unitholder_name: txn.unitholder_name,
            folio_no: txn.folio_no,
            account_title: txn.counter_account_title,
            account_no: txn.counter_account_number,
            bank_name: txn.counter_bank,
            branch_name: txn.counter_branch,
            systematic_investment: txn.systematic_investment || {},
          };
          if (txn.txnr_type === "changeofallocation")
            SetCurrentSubFundsBlock(
              txn.systematic_investment?.previous_allocation || {},
            );
          setUnitholderOptions([unitholderData]);
          handleUnitholderChange(unitholderData);
        }
        toast.success("Transaction details loaded successfully!");
      } else {
        toast.error("Failed to fetch transaction details.");
      }
      setTxnLoading(false);
    } catch (err: any) {
      toast.error(
        err?.response?.data?.message ||
          "An error occurred while fetching transaction details.",
      );
      setTxnLoading(false);
    }
  };

  const selectedSystematicVPSType = useMemo(() => {
    return typeVPS
      ? {
          value: typeVPS,
          label: typeVPS,
        }
      : null;
  }, [typeVPS]);

  const handleClearCounterFund = (blockId, fundIndex) => {
    setSubFundsBlocks((prevBlocks) =>
      prevBlocks.map((block) => {
        if (block.id !== blockId) return block;

        const updatedSubFunds = [...block.subFunds];
        const fundBlock = { ...updatedSubFunds[fundIndex] };

        // Get the current counter fund if it exists
        const counterFundCode = fundBlock.counter_fund?.value;
        if (!counterFundCode) return block;

        // Find counter fund index
        const counterIndex = updatedSubFunds.findIndex(
          (item) => item.fund_code === counterFundCode,
        );

        const currentFunds = currentSubFundsBlock.find(
          (b) => b.id === blockId,
        ).subFunds;

        const currentBlockData = currentFunds[fundIndex];

        if (counterIndex > -1) {
          const counterFundBlock = { ...updatedSubFunds[counterIndex] };

          // Get original data from saved allocation
          const currentCounterBlock = currentFunds[counterIndex];

          // Subtract current fund's amount and units from counter fund
          counterFundBlock.amount = Math.max(
            0,
            (counterFundBlock.amount || 0) - (fundBlock.amount || 0),
          );
          counterFundBlock.units = Math.max(
            0,
            (counterFundBlock.units || 0) - (fundBlock.units || 0),
          );

          // Reset counter fund proportion to original if no more allocation
          if (counterFundBlock.amount === 0) {
            counterFundBlock.proportion = parseFloat(
              currentCounterBlock.proportion,
            );
            delete counterFundBlock.allocation_type;
            delete counterFundBlock.sending_funds;
          } else {
            counterFundBlock.sending_funds =
              counterFundBlock.sending_funds.filter(
                (item: string) => item === currentBlockData.fund_code,
              );
          }

          updatedSubFunds[counterIndex] = counterFundBlock;
        }

        // Reset current fund to original state
        fundBlock.amount = 0;
        fundBlock.units = 0;
        fundBlock.proportion = parseFloat(currentBlockData.proportion);
        delete fundBlock.allocation_type;

        // Clear the counter fund selection
        fundBlock.counter_fund = { value: "", label: "" };

        updatedSubFunds[fundIndex] = fundBlock;

        return { ...block, subFunds: updatedSubFunds };
      }),
    );

    setErrors({});
  };

  const handleChangeAllocation = (
    blockId,
    fundIndex,
    value,
    currentRange,
    counterIndex,
  ) => {
    setErrors({});
    setSubFundsBlocks((prevBlocks) =>
      prevBlocks.map((block) => {
        if (block.id !== blockId) return block;

        const updatedSubFunds = [...block.subFunds];
        const fundBlock = { ...updatedSubFunds[fundIndex] };

        const currentFunds = currentSubFundsBlock.find(
          (b) => b.id === blockId,
        ).subFunds;

        const counterFundBlock =
          counterIndex > -1 ? { ...updatedSubFunds[counterIndex] } : null;

        // Unitholder Dbs Saved Allocation Data
        const currentBlockData = currentFunds[fundIndex];
        const currentCounterBlock =
          counterIndex > -1 ? currentFunds[counterIndex] : null;

        const originalProportion = parseFloat(currentBlockData.proportion);

        const counterOriginalProp =
          counterIndex > -1 ? parseFloat(currentCounterBlock.proportion) : 0;

        const [minRange, maxRange] = currentRange.map(Number);

        // Update raw proportion so typing continues
        fundBlock.proportion = value;
        updatedSubFunds[fundIndex] = fundBlock;

        if (value > maxRange || value < minRange) {
          return { ...block, subFunds: updatedSubFunds };
        }

        // Prevent unnecessary update loop
        if (!isNaN(originalProportion) && originalProportion === value) {
          // Resetting the States
          fundBlock.units = 0;
          fundBlock.amount = 0;
          fundBlock.proportion = originalProportion;
          delete fundBlock.allocation_type;
          updatedSubFunds[fundIndex] = fundBlock;

          if (counterFundBlock && counterIndex > -1) {
            // Resetting the States
            counterFundBlock.units = 0;
            counterFundBlock.amount = 0;
            delete counterFundBlock.allocation_type;
            counterFundBlock.proportion = counterOriginalProp;
            updatedSubFunds[counterIndex] = counterFundBlock;
          }
          return { ...block, subFunds: updatedSubFunds };
        }

        // 2. Determine In or Out based on increase/decrease
        const isIncreasing = value > originalProportion;
        fundBlock.allocation_type = isIncreasing
          ? "conversionin"
          : "conversionout";

        // Update proportion
        const proportionToAllocate = Math.abs(originalProportion - value);

        const investmentAmount = fundBlock.holding * fundBlock.nav;

        const amountToProcess =
          ((investmentAmount / (originalProportion / 100)) *
            proportionToAllocate) /
          100;

        fundBlock.amount = amountToProcess;
        fundBlock.units = amountToProcess / fundBlock.nav;

        if (counterFundBlock) {
          // Calculate its updated proportion
          const prevType = counterFundBlock?.allocation_type || "";
          counterFundBlock.allocation_type = isIncreasing
            ? "conversionout"
            : "conversionin";

          if (prevType && prevType !== counterFundBlock.allocation_type) {
            toast.error(
              `Invalid Allocation for  ${counterFundBlock.fund_code}`,
            );
            return block;
          }

          let counterProportion = counterOriginalProp;

          if (counterFundBlock.allocation_type === "conversionin") {
            if (!counterFundBlock?.sending_funds)
              counterFundBlock.sending_funds = [fundBlock.fund_code];
            else if (
              !counterFundBlock.sending_funds.includes(fundBlock.fund_code)
            ) {
              counterProportion = counterFundBlock.proportion;
              counterFundBlock.sending_funds.push(fundBlock.fund_code);
            }
          }

          const counterNewProportion = isIncreasing
            ? counterProportion - proportionToAllocate
            : counterProportion + proportionToAllocate;

          // Get counter range
          const [counterMin, counterMax] = String(
            renderRange(counterFundBlock?.type_VPS),
          )
            .replace("%", "")
            .split("-")
            .map(Number);

          // If counter goes out of its range → STOP EVERYTHING
          if (
            counterNewProportion < counterMin ||
            counterNewProportion > counterMax
          ) {
            toast.warn("Counter Fund Allocation Limits Violated");
            // return block; // Discard changes
          }

          // Proceed with counter movement
          counterFundBlock.proportion = counterNewProportion;
          counterFundBlock.amount =
            parseFloat(counterFundBlock.amount) + amountToProcess;
          counterFundBlock.units =
            parseFloat(counterFundBlock.units) +
            amountToProcess / counterFundBlock.nav;

          updatedSubFunds[counterIndex] = counterFundBlock;
        }

        updatedSubFunds[fundIndex] = fundBlock;

        return { ...block, subFunds: updatedSubFunds };
      }),
    );
  };

  // Update the handleSubFundChange to call handleClearCounterFund when clearing
  const handleSubFundChange = (blockId, fundIndex, selectedFund) => {
    // If clearing the selection (empty value)
    if (!selectedFund?.value) {
      handleClearCounterFund(blockId, fundIndex);
      return;
    }
    // Existing logic for selecting a fund
    setSubFundsBlocks((prevBlocks) =>
      prevBlocks.map((block) => {
        if (block.id !== blockId) return block;

        const updatedSubFunds = [...block.subFunds];
        updatedSubFunds[fundIndex] = {
          ...updatedSubFunds[fundIndex],
          counter_fund: selectedFund,
        };

        return { ...block, subFunds: updatedSubFunds };
      }),
    );
  };

  const handleAmountChange = (blockId, fundIndex, amount, type) => {
    setSubFundsBlocks((prevBlocks) =>
      prevBlocks.map((block) => {
        if (block.id !== blockId) return block;

        const updatedSubFunds = [...block.subFunds];
        const fundBlock = { ...updatedSubFunds[fundIndex] }; // Create a new object

        // Check if value actually changed to prevent infinite loop
        if (type === "in" && fundBlock.amount_in === amount) {
          return block;
        }
        if (type === "out" && fundBlock.amount_out === amount) {
          return block;
        }

        const nav =
          type === "out" ? fundBlock.redemption_price : fundBlock.offer_price;
        fundBlock.holding = parseFloat(fundBlock.holding).toFixed(4);
        // Update the appropriate field
        if (type === "in") {
          fundBlock.amount_in = amount;
        } else {
          if (
            nav &&
            amount >
              parseFloat((parseFloat(fundBlock.holding) * nav).toFixed(4))
          ) {
            toast.warn("Invalid allocation out amount");
            return block;
          }
          fundBlock.amount_out = amount;
        }

        // Calculate units and set allocation type
        fundBlock.units = amount / parseFloat(nav);
        fundBlock.allocation_type =
          type === "out" ? "conversionout" : "conversionin";

        // Update the subfunds array
        updatedSubFunds[fundIndex] = fundBlock;

        return { ...block, subFunds: updatedSubFunds };
      }),
    );
  };

  const onSubmitStatus = async (data: any) => {
    try {
      const response = await updateVPSTxn(data);

      if (response.data?.status !== 200) {
        toast.error(response.data?.message || "Something went wrong");
      } else {
        toast.success(response.data?.message || "Transaction Status Updated");
        setTimeout(() => {
          history.push("/admin/recent-transactions");
        }, 500);
      }
    } catch (error: any) {
      toast.error(error.message || "Something went wrong");
    }
  };

  const fetchChartOfAccountsForSubFunds = async () => {
    if (subFundsBlocks.length === 0) return;

    try {
      const chartPromises = subFundsBlocks.flatMap((block) =>
        block.subFunds.map(async (fund) => {
          if (!fund.fund_code) return null;

          // Skip if already fetched
          if (chartOfAccountsMap[fund.fund_code]) {
            return {
              fundCode: fund.fund_code,
              chart: chartOfAccountsMap[fund.fund_code],
            };
          }

          try {
            const response = await getNewChartsOfAccountsByFund(
              email,
              fields.amc_code,
              fund.fund_code,
            );

            if (response.data.status === 200) {
              return {
                fundCode: fund.fund_code,
                chart: response.data.data.main_family,
              };
            }
          } catch (error) {
            console.error(
              `Failed to fetch chart for ${fund.fund_code}:`,
              error,
            );
          }
          return null;
        }),
      );

      const results: any = await Promise.all(chartPromises);

      const newChartMap: any = { ...chartOfAccountsMap };
      results.forEach((result) => {
        if (result) {
          newChartMap[result.fundCode] = result.chart;
        }
      });
      setChartOfAccountsMap(newChartMap);
    } catch (error) {
      console.error("Error fetching chart of accounts:", error);
    }
  };

  /**
   * Creates ledger entries for VPS transactions
   * Recreates whenever:
   * - Account changes (handleSubFundAccountChange)
   * - Amount changes (withdrawal/changeofallocation)
   * - Investment amount is static once set
   */
  const createVPSLedgers = useCallback(() => {
    if (!noNav) return;
    // Validations
    if (!fields.amc_code || !fields.folio_no) {
      return null;
    }

    if (subFundsBlocks.length === 0) {
      return null;
    }
    const navErrors: string[] = [];

    // Check if all chart of accounts are loaded
    const missingCharts: any = [];
    for (const block of subFundsBlocks) {
      for (const fund of block.subFunds) {
        if (parseFloat(fund.nav || "0") < 0)
          navErrors.push(`Nav is empty for ${fund.fund_code} on the sale date`);
        if (!chartOfAccountsMap[fund.fund_code]) {
          missingCharts.push(fund?.fund_code);
        }
        if (!fund.selected_account || !fund.account_no) {
          toast.error(`Please select account for fund ${fund.fund_code}`);
          return null;
        }
      }
    }

    if (navErrors.length > 0) {
      console.log("Nav is zero: ", navErrors);
      return null;
    }

    if (missingCharts.length > 0) {
      console.log("Chart of accounts not loaded for:", missingCharts);
      return null;
    }

    // Helper to create ledger entry
    const createLedgerEntry = (
      chartOfAccounts: any[],
      code: string | number,
      type: "Debit" | "Credit",
      amount: number,
      description: string,
      fundCode: string,
      accountInfo: any,
    ) => {
      const info: any = getLedgerInfoByLedgerCodeWorking(chartOfAccounts, code);

      if (!info || !info.gl_code) {
        console.error(`Ledger code ${code} not found for fund ${fundCode}`);
        return null;
      }

      const dateStr = moment(fields.settlement_date).format("YYYY-MM-DD");

      return {
        main_family_code: info.main_family_code,
        main_family_name: info.main_family_name,
        family_code: info.family_code,
        family_name: info.family_name,
        sub_family_code: info.sub_family_code,
        sub_family_name: info.sub_family_name,
        child_family_code: info.child_family_code || 0,
        child_family_name: info.child_family_name || "",
        gl_code: info.gl_code,
        gl_name: info.gl_name,
        amount_type: description,
        type: type,
        amc_code: fields.amc_code,
        fund_code: fundCode,
        account_number: accountInfo?.account_no || "",
        account_title: accountInfo?.account_title || "",
        bank_code: accountInfo?.bank || "",
        branch: accountInfo?.branch || "",
        counter_account_number: fields.counter_account_number,
        counter_account_title: fields.counter_account_title,
        counter_bank: fields.counter_bank,
        counter_branch: fields.counter_branch,
        balance: "",
        credit_amount: type === "Credit" ? amount.toFixed(4) : "0.0000",
        debit_amount: type === "Debit" ? amount.toFixed(4) : "0.0000",
        description: `${description} - ${dateStr}`,
        entered_by: email,
        evidence: "",
        instruction_date: moment(fields.instruction_date).format("YYYY-MM-DD"),
        instrument_by: "",
        instrument_date: moment(fields.instrument_date).format("YYYY-MM-DD"),
        instrument_no: fields.instrument_no || "",
        instrument_type: fields.instrument_type || "",
        realized: "true",
        realized_by: email,
        realized_date: moment(fields.realized_date).format("YYYY-MM-DD"),
        period: sessionStorage.getItem("active_period") || "",
        paid: false,
      };
    };

    try {
      const allLedgers: any[] = [];

      // INVESTMENT: Static once amount is set
      if (viewMode === "investment") {
        subFundsBlocks.forEach((block) => {
          block.subFunds.forEach((fund) => {
            const fundAmount = parseFloat(fund.amount || 0);
            if (fundAmount <= 0) return;

            const fundChart = chartOfAccountsMap[fund.fund_code];
            if (!fundChart) return;

            // Get asset and liability codes
            let assetCode = null;
            let liabilityCode = null;

            // Debit: Bank Account (money in)
            const debitEntry = createLedgerEntry(
              fundChart,
              fund.selected_account.gl_code,
              "Debit",
              fundAmount,
              `Investment - ${fund.fund_code}`,
              fund.fund_code,
              fund.selected_account,
            );

            // Credit: Liability (unitholder account)
            const creditEntry = createLedgerEntry(
              fundChart,
              fund.selected_account.gl_code,
              "Credit",
              fundAmount,
              `Investment - ${fund.fund_name}`,
              fund.fund_code,
              fund.selected_account,
            );

            // console.log(debitEntry);
            // console.log(creditEntry);

            if (debitEntry) {
              allLedgers.push(debitEntry, creditEntry);
            }
          });
        });
      }

      // WITHDRAWAL: Changes with amount
      else if (viewMode === "withdrawal" && amount > 0) {
        subFundsBlocks.forEach((block) => {
          block.subFunds.forEach((fund) => {
            const fundAmount = parseFloat(fund.amount || 0);
            if (fundAmount <= 0) return;

            const fundChart = chartOfAccountsMap[fund.fund_code];
            if (!fundChart) return;

            let assetCode = null;
            let liabilityCode = null;
            fund.selected_account.related_ledgers?.forEach((code) => {
              const codeStr = String(code);
              if (codeStr.startsWith("1")) assetCode = code;
              if (codeStr.startsWith("3")) liabilityCode = code;
            });

            if (!assetCode || !liabilityCode) {
              console.error(`Missing ledger codes for ${fund.fund_code}`);
              return;
            }

            // Credit: Bank Account (money out)
            const creditEntry = createLedgerEntry(
              fundChart,
              fund.selected_account.code,
              "Credit",
              fundAmount,
              `Withdrawal - ${fund.fund_name}`,
              fund.fund_code,
              fund.selected_account,
            );

            // Debit: Liability (unitholder account)
            const debitEntry = createLedgerEntry(
              fundChart,
              liabilityCode,
              "Debit",
              fundAmount,
              `Withdrawal - ${fund.fund_name}`,
              fund.fund_code,
              fund.selected_account,
            );

            if (debitEntry && creditEntry) {
              allLedgers.push(creditEntry, debitEntry);
            }
          });
        });
      }

      // CHANGE OF ALLOCATION: Changes with amount_in/amount_out
      else if (viewMode === "changeofallocation" && amount > 0) {
        subFundsBlocks.forEach((block) => {
          block.subFunds.forEach((fund) => {
            if (!fund.allocation_type) return;

            const fundChart = chartOfAccountsMap[fund.fund_code];
            if (!fundChart) return;

            let liabilityCode = null;
            fund.selected_account.related_ledgers?.forEach((code) => {
              const codeStr = String(code);
              if (codeStr.startsWith("3")) liabilityCode = code;
            });

            if (!liabilityCode) {
              console.error(`Missing liability code for ${fund.fund_code}`);
              return;
            }

            // Conversion Out
            if (fund.allocation_type === "conversionout") {
              const amountOut = parseFloat(fund.amount_out || 0);
              if (amountOut <= 0) return;

              const debitEntry = createLedgerEntry(
                fundChart,
                liabilityCode,
                "Debit",
                amountOut,
                `Change of Allocation Out - ${fund.fund_name}`,
                fund.fund_code,
                fund.selected_account,
              );

              if (debitEntry) allLedgers.push(debitEntry);
            }
            // Conversion In
            else if (fund.allocation_type === "conversionin") {
              const amountIn = parseFloat(fund.amount_in || 0);
              if (amountIn <= 0) return;

              const creditEntry = createLedgerEntry(
                fundChart,
                liabilityCode,
                "Credit",
                amountIn,
                `Change of Allocation In - ${fund.fund_name}`,
                fund.fund_code,
                fund.selected_account,
              );

              if (creditEntry) allLedgers.push(creditEntry);
            }
          });
        });
      }

      // Validate balance
      const totalDebit = allLedgers.reduce(
        (sum, l) => sum + parseFloat(l.debit_amount),
        0,
      );
      const totalCredit = allLedgers.reduce(
        (sum, l) => sum + parseFloat(l.credit_amount),
        0,
      );

      if (Math.abs(totalDebit - totalCredit) > 0.01) {
        console.error(
          `Ledgers unbalanced: Debit=${totalDebit}, Credit=${totalCredit}`,
        );
        return null;
      }

      return allLedgers;
    } catch (error) {
      console.error("Error creating VPS ledgers:", error);
      return null;
    }
  }, [fields, subFundsBlocks, chartOfAccountsMap, viewMode, email]);

  useEffect(() => {
    if (subFundsBlocks.length > 0 && viewMode !== "view") {
      fetchChartOfAccountsForSubFunds();
    }
  }, [subFundsBlocks]);

  // Recreate ledgers when dependencies change
  useEffect(() => {
    if (viewMode === "view") return;

    const ledgers = createVPSLedgers();
    console.log(ledgers);

    if (ledgers) {
      setVpsLedgers(ledgers);
    }
  }, [createVPSLedgers]);

  return {
    viewMode,
    loadingViewData,
    fields,
    setFields,
    updateField,
    amcOptions,
    fundOptions,
    accountOptions,
    unitholderAccountOptions,
    modeOfPayments,
    instrumentTypes,
    loading,
    errorShow,
    handleAmcChange,
    handleFundChange,
    handleAccountChange,
    handleSaleDateChange,
    handleSubmit,
    getErrorClass,
    history,
    unitholderOptions,
    unitholderLoading,
    handleUnitholderChange,
    handleUnitholderInputChange,
    renderRange,
    removeSubFundsBlock,
    onAmountChange,
    handleCustomCheckboxChange,
    allFunds,
    setAllFunds,
    errors,
    setErrors,
    rangeTimer,
    setRangeTimer,
    autoInvest,
    setAutoInvest,
    typeVPS,
    setTypeVPS,
    unitholderType,
    setUnitholderType,
    amount,
    setAmount,
    fundLoading,
    setFundLoading,
    subFundsBlocks,
    setSubFundsBlocks,
    customStyles,
    fundAccountsMap,
    handleSubFundAccountChange,
    fetchAccountsForFund,
    calculateUnits,
    navLoading,
    setUnitholderOptions,
    currentSubFundsBlock,
    SetCurrentSubFundsBlock,
    handleChangeAllocation,
    handleSubFundChange,
    selectedSystematicVPSType,
    currAmount,
    setIndexedError,
    handleAmountChange,
    totalAmount,
    totalUnits,
    setUnits,
    units,
    offerPrice,
    id,
    showApproval,
    setShowApproval,
    authroizeDialogue,
    setAuthorizeDialogue,
    fetchNavForFund,
    calculateBlockTotal,
    decision,
    setDecision,
    rejectReason,
    setRejectReason,
    onSubmitStatus,
    compliant,
    setCompliant,
    compliantComment,
    setcompliantComment,
    noNav,
    updateNav,
    chartOfAccountsMap,
    vpsLedgers,
    fetchChartOfAccountsForSubFunds,
    createVPSLedgers,
  };
};
